import { Typography, styled } from '@mui/material';
import { capitalize } from 'helpers/helpers';
import { camelize } from 'helpers/syntaxHelper';
import { translateBlock } from 'i18n';
import React from 'react';
import { FilterItemProps } from './FilterItemDisplay';

const NoValueFilterItem = ({ filter }: FilterItemProps) => {
    const StyTypography = styled(Typography, {
        name: 'StyChip',
    })(({ theme }) => ({
        color: theme.palette.mediumGrey,
    }));
    return (
        <StyTypography>
            {capitalize(translateBlock(camelize(filter.field)))}
        </StyTypography>
    );
};

export default NoValueFilterItem;
